import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbAssembleiaItemOpcaoVoto } from 'app/abstract/full-pages/assembleia/assembleia-item-opcao-voto.abstract';

@Injectable({ providedIn: 'root' })
export class AssembleiaItemOpcaoVotoService extends AbAssembleiaItemOpcaoVoto {
  prefixo = 'item_assembleia_opcao_votos/';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getOpsVotoByItemIdId(id: any) {
    return this.get(`${this.prefixo}item/`, id);
  }

  public downloadArquivoItemAssembleiaOpcaoVoto(itemAssembleiaIdOpcaoVoto: number, nomeArquivo: string) {
    return this.get(`${this.prefixo}arquivo/download/${itemAssembleiaIdOpcaoVoto}/${nomeArquivo}`);
  }

}
